// Minimal API client for the Stammtisch Challenge backend.
const BASE = process.env.REACT_APP_BACKEND_URL;

export async function submitParticipation(input) {
  const res = await fetch(`${BASE}/api/participations`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`Envoi échoué (${res.status}): ${txt}`);
  }
  return res.json();
}

export async function adminVerify(pin) {
  const res = await fetch(`${BASE}/api/admin/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ pin }),
  });
  return res.ok;
}

export async function adminListParticipations(pin) {
  const res = await fetch(`${BASE}/api/admin/participations`, {
    headers: { "X-Admin-Pin": pin },
  });
  if (!res.ok) throw new Error(`Chargement échoué (${res.status})`);
  return res.json();
}

export async function adminStats(pin) {
  const res = await fetch(`${BASE}/api/admin/stats`, {
    headers: { "X-Admin-Pin": pin },
  });
  if (!res.ok) throw new Error(`Stats échouées (${res.status})`);
  return res.json();
}

export function exportCsvUrl() {
  return `${BASE}/api/admin/export.csv`;
}
